<template>
	<a-modal :title="isUpdate ? '修改礼物' : '新增礼物'" :width="640" :visible="visible" :confirmLoading="false"
		:maskClosable="false" @ok="handleOk" @cancel="handleCancel">
		<a-spin :spinning="loading">
			<a-form-model ref="adminForm" :model="form" :label-col="{span:6}" :wrapper-col="{span:14}" autoComplete="off">
				<a-form-model-item v-show="false" label="ID" prop="id">
					<a-input type="hidden" v-model.number="form.id" />
				</a-form-model-item>
				<a-form-model-item label="礼物名称" prop="giftName"
					:rules="[
						{ required: true, message: '必填，不能为空', trigger: 'blur' },
						{ validator: isExistGiftName, trigger: 'blur' }
					]">
					<a-input v-model="form.giftName" style="width:200px" />
				</a-form-model-item>

				<a-form-model-item label="图片" prop="picUrl"
					:rules="[{ required: true, message: '必填，不能为空', trigger: 'change' }]">
					<x-image :src="picUrl"
						:preview-src="picUrl + '?x-oss-process=image/resize,w_64,h_64,m_fill'"></x-image>
					<a-input v-show="false" v-model="form.picUrl" />
					<a-upload listType="picture" :multiple="false" :showUploadList="false" :customRequest="picUpload">
						<a-button><a-icon type="upload" />上传</a-button>
					</a-upload>
				</a-form-model-item>

				<a-form-model-item label="svga动画" prop="codeUrl"
					:rules="[{ required: true, message: '必填，不能为空', trigger: 'change' }]">
					<a-input v-show="false" v-model="form.codeUrl" />
					<a-upload :file-list="fileList" :customRequest="svgaUpload" :remove="handleRemove"
						:before-upload="beforeUpload" :multiple="false" accept=".svga">
						<a-button> <a-icon type="upload" />选择文件</a-button>
					</a-upload>
				</a-form-model-item>

				<a-form-model-item label="价格" prop="price"
					:rules="[
						{ required: true, message: '必填，不能为空', trigger: 'blur' },
						{ validator: validatePositiveInteger, trigger: 'blur' }
					]">
					<a-input v-model="form.price" style="width:100px" @keypress="handleKeyPress" />
				</a-form-model-item>

				<a-form-model-item label="排序" prop="seq"
					:rules="[{ required: true, message: '必填，不能为空', trigger: 'blur' }]">
					<a-input v-model="form.seq" style="width:100px" />
				</a-form-model-item>

			</a-form-model>
		</a-spin>
	</a-modal>
</template>

<script>
	import pick from 'lodash.pick';
	import XImage from "@/components/XImage";
	import {
		giftNameIsExist
	} from '@/api/content/gift.js';

	import {
		uploadImage,
		uploadSvga
	} from '@/api/app';

	const fields = ['id', 'giftName', 'picUrl', 'codeUrl', 'price', 'seq'];

	function emptyForm() {
		return {
			id: 0,
			giftName: '',
			picUrl: '',
			codeUrl: '',
			price: '',
			seq: '0'
		};
	}

	export default {
		components: {
			XImage
		},
		props: {
			visible: {
				type: Boolean,
				required: true
			},
			loading: {
				type: Boolean,
				default: () => false
			},
			model: {
				type: Object,
				default: () => null
			}
		},
		data() {
			return {
				form: emptyForm(),
				picUrl: '',
				fileList: [],
				uploading: false,
				svgaFileList: [],
				svgaUploading: false,
				svgaUrl: '',
			}
		},
		created() {
			this.unwatch = this.$watch('model', (newVal) => {
				if (!newVal) {
					this.initForm();
					return;
				}

				if (newVal.picUrl) {
					this.picUrl = newVal.picUrl;
				}

				if (newVal.codeUrl) {
					this.svgaUrl = newVal.codeUrl;
					this.fileList = [{
						uid: '-1',
						name: newVal.codeUrl.split('/').pop(),
						status: 'done',
						url: newVal.codeUrl,
						percent: 100
					}];
				} else {
					this.fileList = [];
				}

				this.$nextTick(() => {
					const base = pick(newVal, fields);
					this.form = { ...emptyForm(), ...base };
					if (this.form.seq === undefined || this.form.seq === null) {
						this.form.seq = '0';
					} else {
						this.form.seq = String(this.form.seq);
					}
					if (this.$refs.adminForm) {
						this.$refs.adminForm.clearValidate();
					}
				});
			}, {
				immediate: true
			});
		},
		computed: {
			isUpdate: function() {
				return this.model && this.model.id > 0 ? true : false;
			}
		},
		methods: {
			initForm() {
				this.form = emptyForm();
				this.picUrl = '';
				this.fileList = [];
				this.svgaUrl = '';
				this.$nextTick(() => {
					if (this.$refs.adminForm) {
						this.$refs.adminForm.clearValidate();
					}
				});
			},
			picUpload(file) {
				const self = this;
				const formData = new FormData();
				formData.append('xupload', file.file);
				formData.append('type', 'gift');

				uploadImage(formData).then(res => {
					if (res.isSucceed) {
						this.picUrl = res.data.url;
						this.form.picUrl = res.data.url;
						this.$nextTick(() => {
							if (this.$refs.adminForm) {
								this.$refs.adminForm.validateField('picUrl');
							}
						});
					} else {
						self.$message.error(`上传图片错误：${res.data.message}`);
					}
				});
			},
			handleOk() {
				this.$emit('ok');
			},
			handleCancel() {
				this.$emit('cancel');
				this.resetState();
			},
			resetState() {
			},
			isExistGiftName(rule, value, callback) {
				if (value === undefined || value === '' || (this.model && this.model.giftName === value)) {
					callback();
					return;
				}
				giftNameIsExist(value).then(res => {
					if (res.data) {
						callback(new Error('礼物已存在'));
					} else {
						callback();
					}
				}).catch(() => {
					callback();
				});
			},

			handleRemove(file) {
				const index = this.fileList.indexOf(file);
				const newFileList = this.fileList.slice();
				newFileList.splice(index, 1);
				this.fileList = newFileList;
			},
			beforeUpload(file) {
				console.log('上传前');
				this.fileList = [...this.fileList, file];
				return true;
			},
			svgaUpload(options) {
				const {
					file,
					onProgress,
					onSuccess,
					onError
				} = options;
				const formData = new FormData();
				formData.append('file', file);

				this.fileList = [{
					uid: file.uid,
					name: file.name,
					status: 'uploading',
					percent: 0,
				}];

				uploadSvga(formData, {
					onUploadProgress: (progressEvent) => {
						const percent = Math.round((progressEvent.loaded * 100) / progressEvent.total);
						this.fileList = [{
							...this.fileList[0],
							percent,
						}];
						onProgress({
							percent
						}, file);
					}
				}).then(response => {
					if (response.isSucceed) {
						this.fileList = [{
							...this.fileList[0],
							status: 'done',
							percent: 100,
							url: response.data.url,
						}];

						this.form.codeUrl = response.data.url;
						this.$nextTick(() => {
							if (this.$refs.adminForm) {
								this.$refs.adminForm.validateField('codeUrl');
							}
						});

						onSuccess(response.data, file);
					} else {
						throw new Error(response.message || '上传失败');
					}
				}).catch(error => {
					console.error('上传失败', error);
					this.fileList = [{
						...this.fileList[0],
						status: 'error',
					}];
					onError(error, file);
					this.$message.error(error.message || 'SVGA上传失败');
				});
			},
			handleKeyPress(e) {
				const charCode = e.which ? e.which : e.keyCode;
				if (charCode > 31 && (charCode < 48 || charCode > 57)) {
					e.preventDefault();
				}
			},

			validatePositiveInteger(rule, value, callback) {
				if (value === '' || value === undefined) {
					callback(new Error('请输入价格'));
					return;
				}

				if (isNaN(value)) {
					callback(new Error('请输入有效的数字'));
					return;
				}

				if (!Number.isInteger(Number(value))) {
					callback(new Error('请输入整数'));
					return;
				}

				if (Number(value) <= 0) {
					callback(new Error('请输入正整数'));
					return;
				}

				callback();
			}
		}
	}
</script>

<style scoped>
	.ant-input-number-handler-wrap :deep(.ant-input-number-handler-wrap) {
		display: none;
	}
</style>
